// Dados das 4 páginas de etapa da Maternnia (Etapa 5)
export const ETAPAS_ORDER = ["planejamento", "gestacao", "parto", "pos-parto"];

export const ACCENTS = {
  gold: {
    text: "text-maternnia-gold",
    bg: "bg-maternnia-gold",
    bgHover: "hover:bg-[#a98c5e]",
    soft: "bg-maternnia-gold/10",
    softText: "text-maternnia-gold",
    heroBg: "bg-[#FBF6EC]",
    ring: "focus:ring-maternnia-gold/30",
  },
  pink: {
    text: "text-maternnia-pink",
    bg: "bg-maternnia-pink",
    bgHover: "hover:bg-maternnia-pinkHover",
    soft: "bg-maternnia-pink/10",
    softText: "text-maternnia-pink",
    heroBg: "bg-maternnia-porcelana",
    ring: "focus:ring-maternnia-pink/30",
  },
  eucalipto: {
    text: "text-maternnia-eucalipto",
    bg: "bg-maternnia-eucalipto",
    bgHover: "hover:bg-maternnia-floresta",
    soft: "bg-maternnia-eucalipto/10",
    softText: "text-maternnia-eucalipto",
    heroBg: "bg-[#EEF3EF]",
    ring: "focus:ring-maternnia-eucalipto/30",
  },
  taupe: {
    text: "text-maternnia-taupe",
    bg: "bg-maternnia-taupe",
    bgHover: "hover:bg-[#5b4a4d]",
    soft: "bg-maternnia-taupe/10",
    softText: "text-maternnia-taupe",
    heroBg: "bg-maternnia-nevoa/50",
    ring: "focus:ring-maternnia-taupe/30",
  },
};

export const ETAPAS_DATA = {
  planejamento: {
    slug: "planejamento",
    nome: "Planejamento",
    numero: "01",
    accent: "gold",
    heroImg:
      "https://images.unsplash.com/photo-1668605335558-a13236f088e3?w=1100&q=80&auto=format&fit=crop",
    heroAlt: "Pessoa de costas pesquisando no laptop e anotando em um caderno",
    heroTitle: "Planejar com clareza antes de começar",
    heroSubtitle:
      "Informações para quem está pensando em ter filhos ou tentando engravidar — para tomar decisões com tranquilidade e segurança.",
    descricao:
      "O planejamento é o momento de cuidar de você antes da gravidez: entender sua saúde, organizar a rotina, alinhar expectativas e se preparar emocional e financeiramente. Reunimos o essencial para você dar os primeiros passos com confiança.",
    duvidas: [
      { q: "Quando devo começar a me preparar?", a: "O ideal é iniciar os cuidados de 3 a 6 meses antes de tentar engravidar, incluindo avaliação médica e ajustes de hábitos." },
      { q: "Quais exames pré-concepcionais fazer?", a: "Seu médico pode indicar exames de sangue, sorologias, avaliação ginecológica e, em alguns casos, avaliação genética." },
      { q: "Preciso tomar ácido fólico?", a: "Na maioria dos casos sim, idealmente iniciado antes da concepção. Confirme dose e indicação com seu profissional de saúde." },
    ],
    decisoes: [
      { title: "Escolher um profissional de referência", desc: "Defina ginecologista ou especialista em fertilidade para te acompanhar." },
      { title: "Organizar o planejamento financeiro", desc: "Mapeie custos de consultas, exames e da chegada do bebê." },
      { title: "Avaliar saúde e hábitos", desc: "Nutrição, sono, atividade física e saúde emocional fazem diferença." },
    ],
    checklist: [
      "Marcar consulta pré-concepcional",
      "Iniciar suplementação indicada (ex.: ácido fólico)",
      "Atualizar exames e vacinas",
      "Revisar alimentação e rotina de sono",
      "Conversar sobre planejamento financeiro",
      "Cuidar da saúde emocional",
    ],
    categorias: ["Ginecologistas", "Clínicas de fertilidade", "Nutricionistas", "Psicólogos", "Laboratórios"],
    temasChips: ["Saúde pré-concepcional", "Fertilidade", "Reprodução assistida", "Exames", "Planejamento financeiro", "Nutrição", "Saúde emocional"],
  },

  gestacao: {
    slug: "gestacao",
    nome: "Gestação",
    numero: "02",
    accent: "pink",
    heroImg:
      "https://static.prod-images.emergentagent.com/jobs/424cc6d9-f0bf-4897-9d6b-2170e84bc4d8/images/8d824a0405e7368852a125db122bee3666c4c82a2b40b4c0284606a6fb6f943a.png",
    heroAlt: "Gestante negra acariciando a barriga em formato de coração",
    heroTitle: "Acompanhe cada fase da sua gravidez",
    heroSubtitle:
      "Conteúdos, checklists e profissionais para o primeiro, segundo e terceiro trimestre — com informação confiável a cada passo.",
    descricao:
      "A gestação é uma jornada de transformações. Organizamos os conteúdos por trimestre para que você saiba o que esperar, quais exames realizar e como cuidar do corpo e das emoções em cada fase.",
    trimestres: [
      { titulo: "1º trimestre", desc: "Confirmação, primeiras consultas de pré-natal, exames iniciais e adaptação aos sintomas." },
      { titulo: "2º trimestre", desc: "Fase de mais energia: exames morfológicos, alimentação e atividade física com segurança." },
      { titulo: "3º trimestre", desc: "Preparação para o parto, plano de parto, enxoval e sinais de trabalho de parto." },
    ],
    duvidas: [
      { q: "Quando começa o pré-natal?", a: "Idealmente assim que a gravidez é confirmada. O acompanhamento regular é essencial em todos os trimestres." },
      { q: "Quais exames são comuns?", a: "Ultrassonografias, exames de sangue, teste de tolerância à glicose e o morfológico, conforme orientação médica." },
      { q: "Posso me exercitar grávida?", a: "Em geral sim, com liberação e orientação profissional. Atividades de baixo impacto costumam ser indicadas." },
    ],
    decisoes: [
      { title: "Definir a equipe de pré-natal", desc: "Obstetra e, se desejar, doula e fisioterapeuta pélvica." },
      { title: "Planejar exames e calendário", desc: "Organize consultas e exames de cada trimestre." },
      { title: "Cuidar da alimentação", desc: "Acompanhamento nutricional ajuda em cada fase." },
    ],
    checklist: [
      "Iniciar e manter o pré-natal",
      "Organizar calendário de exames",
      "Acompanhamento nutricional",
      "Considerar fisioterapia pélvica",
      "Cuidar da saúde emocional",
      "Começar a preparação para o parto",
    ],
    categorias: ["Obstetras", "Nutricionistas", "Fisioterapeutas pélvicos", "Psicólogos perinatais", "Cursos de gestante"],
    temasChips: ["Pré-natal", "Exames", "Alimentação", "Sintomas", "Atividade física", "Preparação", "Saúde emocional"],
  },

  parto: {
    slug: "parto",
    nome: "Parto",
    numero: "03",
    accent: "eucalipto",
    heroPortrait: true,
    heroImg:
      "https://customer-assets.emergentagent.com/job_pregnancy-platform/artifacts/zmire97u_file_00000000443471f4a54041f5a3a315c8.png",
    heroAlt: "Mãe oriental sendo amparada ao chegar à maternidade",
    heroTitle: "Prepare suas decisões para o grande dia",
    heroSubtitle:
      "Entenda as opções de parto, monte seu plano e organize a equipe e a rede de apoio que respeitam suas escolhas.",
    descricao:
      "O parto é um momento único e cheio de decisões. Ajudamos você a compreender os tipos de parto, seus direitos, como montar o plano de parto e escolher maternidade, equipe e acompanhante com segurança.",
    duvidas: [
      { q: "O que é um plano de parto?", a: "É um documento com suas preferências para o trabalho de parto, parto e pós-parto imediato, compartilhado com a equipe." },
      { q: "Quais são meus direitos?", a: "Você tem direito a acompanhante, a informação clara sobre procedimentos e a um atendimento respeitoso e seguro." },
      { q: "Vale a pena ter doula?", a: "A doula oferece apoio físico e emocional contínuo. Muitas famílias relatam mais conforto e segurança com esse suporte." },
    ],
    decisoes: [
      { title: "Escolher a maternidade", desc: "Avalie estrutura, localização e alinhamento com suas preferências." },
      { title: "Montar o plano de parto", desc: "Registre suas escolhas e converse com a equipe." },
      { title: "Definir equipe e acompanhante", desc: "Obstetra, doula e acompanhante de confiança." },
    ],
    checklist: [
      "Estudar os tipos de parto",
      "Escrever o plano de parto",
      "Escolher e visitar a maternidade",
      "Definir equipe e acompanhante",
      "Considerar uma doula",
      "Preparar a bolsa de enxoval",
    ],
    categorias: ["Obstetras", "Doulas", "Maternidades", "Cursos de gestante", "Fisioterapeutas pélvicos"],
    temasChips: ["Tipos de parto", "Plano de parto", "Maternidade", "Equipe", "Doula", "Acompanhante", "Direitos", "Preparação"],
  },

  "pos-parto": {
    slug: "pos-parto",
    nome: "Pós-parto",
    numero: "04",
    accent: "taupe",
    heroImg:
      "https://static.prod-images.emergentagent.com/jobs/424cc6d9-f0bf-4897-9d6b-2170e84bc4d8/images/c12426409063711673535887afe4fea52b244d8a494bc8e3bfaafeb5e6e75b5f.png",
    heroAlt: "Pezinhos de bebê pardo acolhidos pelas mãos de um adulto",
    heroTitle: "Apoio para você e para o bebê",
    heroSubtitle:
      "Recuperação, amamentação, sono, saúde emocional e primeiros cuidados — com a rede de apoio que você merece.",
    descricao:
      "O pós-parto pede cuidado com a mãe e com o bebê. Reunimos orientações sobre recuperação, puerpério, amamentação, sono e saúde emocional, além de profissionais para apoiar essa nova fase.",
    duvidas: [
      { q: "O que é o puerpério?", a: "É o período de recuperação após o parto, com mudanças físicas e emocionais que merecem atenção e apoio." },
      { q: "Como buscar ajuda com a amamentação?", a: "Consultoras de amamentação e pediatras podem orientar pega, frequência e dúvidas comuns." },
      { q: "Quando procurar ajuda emocional?", a: "Tristeza intensa, ansiedade ou desânimo persistentes merecem avaliação de um profissional de saúde mental." },
    ],
    decisoes: [
      { title: "Escolher o pediatra", desc: "De preferência ainda antes do nascimento." },
      { title: "Organizar a rede de apoio", desc: "Família, parceiros e profissionais para os primeiros dias." },
      { title: "Cuidar da saúde emocional", desc: "Acompanhamento psicológico quando necessário." },
    ],
    checklist: [
      "Escolher o pediatra",
      "Buscar apoio com a amamentação",
      "Organizar descanso e sono",
      "Cuidar da recuperação física",
      "Atenção à saúde emocional",
      "Montar a rede de apoio",
    ],
    categorias: ["Pediatras", "Consultoras de amamentação", "Psicólogos perinatais", "Fisioterapeutas", "Enfermeiras"],
    temasChips: ["Recuperação", "Puerpério", "Amamentação", "Saúde emocional", "Sono", "Pediatria", "Rede de apoio", "Primeiros cuidados"],
  },
};

export const CONTEUDOS_POR_ETAPA = {
  planejamento: [
    { title: "Como começar a planejar uma gravidez", min: "6 min" },
    { title: "Exames pré-concepcionais: o guia", min: "5 min" },
    { title: "Saúde emocional antes de engravidar", min: "4 min" },
  ],
  gestacao: [
    { title: "O que organizar no primeiro trimestre", min: "7 min" },
    { title: "Como escolher um obstetra", min: "5 min" },
    { title: "Alimentação saudável na gravidez", min: "6 min" },
  ],
  parto: [
    { title: "Doula: o que faz e quando contratar", min: "8 min" },
    { title: "Como montar seu plano de parto", min: "6 min" },
    { title: "Tipos de parto: entenda as opções", min: "7 min" },
  ],
  "pos-parto": [
    { title: "Como se preparar para o pós-parto", min: "6 min" },
    { title: "Como escolher um pediatra antes do nascimento", min: "5 min" },
    { title: "Amamentação: primeiros dias com apoio", min: "6 min" },
  ],
};

export const FORNECEDORES_DESTAQUE = {
  planejamento: [
    { nome: "Clínica Vida Fértil", tipo: "Reprodução assistida" },
    { nome: "NutriMaterna", tipo: "Nutrição pré-concepcional" },
    { nome: "Espaço Equilíbrio", tipo: "Saúde emocional" },
  ],
  gestacao: [
    { nome: "Dra. Helena Prado", tipo: "Obstetrícia" },
    { nome: "Movimento Pélvico", tipo: "Fisioterapia pélvica" },
    { nome: "Curso Gestar", tipo: "Preparação para o parto" },
  ],
  parto: [
    { nome: "Maternidade Acolher", tipo: "Maternidade humanizada" },
    { nome: "Doulas do Bem", tipo: "Doulas" },
    { nome: "Plano Nascer", tipo: "Consultoria de parto" },
  ],
  "pos-parto": [
    { nome: "Pediatria Crescer", tipo: "Pediatria" },
    { nome: "Amamenta Bem", tipo: "Consultoria de amamentação" },
    { nome: "Cuidar Materno", tipo: "Saúde emocional" },
  ],
};
